<template>
  <div>
    <el-dialog
      title="选择销售退货单"
      :visible="show"
      width="1000px"
      @close="close"
    >
      <el-form inline :model="searchData">
        <el-form-item>
          <el-input
            placeholder="单号/销售单号/客户/制单人"
            clearable
            prefix-icon="el-icon-search"
            v-model="searchData.searchInputValue"
            style="width: 250px"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="付款进度">
          <EnumSelect
            enumName="FundPayProgressEnum"
            placeholder="请选择单据付款进度"
            v-model="searchData.fundPayProgressEnumList"
            @change="changeAndSearch"
          >
          </EnumSelect>
        </el-form-item>
        <el-form-item label="入库进度">
          <EnumSelect
            enumName="CommodityInputProgressEnum"
            placeholder="请选择单据入库进度"
            v-model="searchData.commodityInputProgressEnumList"
            @change="changeAndSearch"
          >
          </EnumSelect>
        </el-form-item>
        <el-form-item label="发货标识">
          <BooleanSelect
            v-model="searchData.shippedMark"
            trueLabel="已发货"
            falseLabel="未发货"
            @change="changeAndSearch"
          ></BooleanSelect>
        </el-form-item>
        <el-form-item label="收款标识">
          <BooleanSelect
            v-model="searchData.collectedMark"
            trueLabel="已收款"
            falseLabel="未收款"
            @change="changeAndSearch"
          ></BooleanSelect>
        </el-form-item>
        <el-form-item label="单据金额">
          <NumberRangeInput
            :precision="2"
            :minVal.sync="searchData.minOrderAmount"
            :maxVal.sync="searchData.maxOrderAmount"
            @change="changeAndSearch"
          ></NumberRangeInput>
        </el-form-item>
        <el-form-item label="单据日期">
          <DateRangePicker
            :minVal.sync="searchData.minOrderDate"
            :maxVal.sync="searchData.maxOrderDate"
            @change="changeAndSearch"
          ></DateRangePicker>
        </el-form-item>
        <el-form-item label="制单时间">
          <DateRangePicker
            :minVal.sync="searchData.minCreateDate"
            :maxVal.sync="searchData.maxCreateDate"
            @change="changeAndSearch"
          ></DateRangePicker>
        </el-form-item>
        <el-form-item label="提交时间">
          <DateRangePicker
            :minVal.sync="searchData.minSubmitDate"
            :maxVal.sync="searchData.maxSubmitDate"
            @change="changeAndSearch"
          ></DateRangePicker>
        </el-form-item>
        <el-form-item>
          <el-button
            icon="el-icon-search"
            type="primary"
            size="mini"
            @click="changeAndSearch"
            :loading="searchLoading"
          >
            查询
          </el-button>
          <el-button
            icon="el-icon-refresh"
            size="mini"
            @click="resetAndSearch"
            :loading="searchLoading"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>

      <el-table
        v-loading="searchLoading"
        :data="searchRes && searchRes.data ? searchRes.data : []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        ref="refsTable"
        @sort-change="sortChange"
        max-height="400px"
      >
        <el-table-column
          prop="orderNo"
          label="单号"
          width="150"
          align="center"
          header-align="center"
          fixed="left"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span v-fmtype="scope.row.orderNo ? '' : 'info'">
              {{ scope.row.orderNo || "暂无" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderDate"
          label="单据日期"
          width="110"
          align="center"
          header-align="center"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="orderApprovalStatusEnum.Desc"
          label="审批状态"
          width="150"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <span
              v-fmtype="
                $jsTool.getOrderApprovalStatusType(
                  scope.row.orderApprovalStatusEnum
                )
              "
              >{{ scope.row.orderApprovalStatusEnum.Desc }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="customer.customerNo"
          label="客户"
          width="200"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.customer.customerNo }}<br />
            {{ scope.row.customer.name }}
          </template>
        </el-table-column>
        <el-table-column
          prop="orderInfo.customerName"
          label="联系人信息"
          width="200"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.customerName + " " + scope.row.customerPhoneNumber }}
            <br />
            {{ scope.row.customerAddress }}
          </template>
        </el-table-column>
        <el-table-column
          prop="relatedSaleOrderHead.orderNo"
          label="关联销售单"
          width="150"
          align="center"
          header-align="center"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="orderAmount"
          label="单据金额"
          width="150"
          align="center"
          header-align="center"
          sortable="custom"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="fm-flex">
              <FmAmount :amount="scope.row.orderAmount"></FmAmount>
              <div
                class="fm-flex"
                v-if="scope.row.orderApprovalStatusEnum.Name == 'Approval'"
              >
                <div
                  class="fm-flex"
                  v-if="
                    scope.row.fundPayProgressEnum.Name == 'UnPaid' ||
                    scope.row.fundPayProgressEnum.Name == 'PartialPaid'
                  "
                >
                  <span> (已付</span>
                  <FmAmount :amount="scope.row.completedPayAmount"></FmAmount>
                  <span>)</span>
                </div>
                <div
                  class="fm-flex"
                  v-if="scope.row.fundPayProgressEnum.Name == 'FullPaid'"
                >
                  <span> (实付</span>
                  <FmAmount
                    :amount="
                      $jsTool.sub(
                        scope.row.completedPayAmount,
                        scope.row.payDisCountAmount
                      )
                    "
                  ></FmAmount>
                  <span>)</span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="shippedMark"
          label="发货标识"
          width="100"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
          <el-tooltip slot="header" placement="top">
            <div
              slot="content"
              style="line-height: 1.5em"
              v-html="$jsTool.shippedMarkText()"
            ></div>
            <span>
              <i class="el-icon-question"></i>
              发货标识
            </span>
          </el-tooltip>
          <template slot-scope="scope">
            <span v-fmtype="scope.row.shippedMark ? 'success' : 'warning'">{{
              scope.row.shippedMark ? "已发货" : "未发货"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="collectedMark"
          label="收款标识"
          width="100"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
          <el-tooltip slot="header" placement="top">
            <div
              slot="content"
              style="line-height: 1.5em"
              v-html="$jsTool.collectedMarkText()"
            ></div>
            <span>
              <i class="el-icon-question"></i>
              收款标识
            </span>
          </el-tooltip>
          <template slot-scope="scope">
            <span v-fmtype="scope.row.collectedMark ? 'success' : 'warning'">{{
              scope.row.collectedMark ? "已收款" : "未收款"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fundPayProgressEnum.Desc"
          label="付款进度"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <span
              v-fmtype="
                $jsTool.getFundPayProgressType(scope.row.fundPayProgressEnum)
              "
              v-if="scope.row.orderApprovalStatusEnum.Name == 'Approval'"
              >{{ scope.row.fundPayProgressEnum.Desc }}</span
            >
            <span v-fmtype="'warning'" v-else>——</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="commodityInputProgressEnum.Desc"
          label="入库进度"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <span
              v-fmtype="
                $jsTool.getCommodityInputProgressType(
                  scope.row.commodityInputProgressEnum
                )
              "
              v-if="scope.row.orderApprovalStatusEnum.Name == 'Approval'"
              >{{ scope.row.commodityInputProgressEnum.Desc }}</span
            >
            <span v-fmtype="'warning'" v-else>——</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="saleUser"
          label="业务员"
          width="150"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div class="fm-line-2">
              {{ scope.row.saleUserList.map((d) => d.user.name).join("、") }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          width="150"
          align="left"
          header-align="center"
          sortable="custom"
          show-overflow-tooltip
        >
          <el-tooltip
            slot="header"
            content="点击可按制单时间排序"
            placement="top"
          >
            <span>
              <i class="el-icon-question"></i>
              制单信息
            </span>
          </el-tooltip>
          <template slot-scope="scope">
            {{ scope.row.creator.name }}<br />
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column
          prop="submitUser"
          width="150"
          align="left"
          header-align="center"
          sortable="custom"
          show-overflow-tooltip
        >
          <el-tooltip
            slot="header"
            content="点击可按提交时间排序"
            placement="top"
          >
            <span>
              <i class="el-icon-question"></i>
              提交信息
            </span>
          </el-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.submitUserId">
              {{ scope.row.submitUser.name }}<br />
              {{ scope.row.submitTime }}
            </div>
            <span v-fmtype="'warning'" v-else>——</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          header-align="center"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            <el-button
              @click.native.stop="select(scope.row)"
              type="text"
              icon="el-icon-thumb"
            >
              选择销售退货单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="searchRes && searchRes.pageInfo"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchRes.pageInfo.page"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="searchRes.pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchRes.total"
      >
      </el-pagination>
    </el-dialog>

    <el-dialog
      title="填写付款金额"
      :visible="editItemDialogShow"
      width="600px"
      @close="editItemDialogShow = false"
      v-if="editItemDialogShow"
      v-loading="loading"
    >
      <el-row class="fm-flex">
        <el-col :span="12">
          <span>关联单据</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span>{{ editItem.orderNo }}</span>
          </p>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row class="fm-flex">
        <el-col :span="12">
          <span>单据金额</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span><FmAmount :amount="editItem.orderAmount"></FmAmount></span>
          </p>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row class="fm-flex">
        <el-col :span="12">
          <el-tooltip effect="dark" content="" placement="top-start">
            <div slot="content" style="line-height: 1.5em">
              <div style="font-weight: bold">待付金额说明</div>
              关联单据的最新待付金额
            </div>
            <i class="el-icon el-icon-question fm-mr-5"></i>
          </el-tooltip>
          <span>待付金额</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span><FmAmount :amount="editItem.toBePayAmount"></FmAmount></span>
          </p>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row class="fm-flex">
        <el-col :span="12">
          <span>付款金额</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span>
              <el-input-number
                style="width: 170px"
                v-model="nowPayAmount"
                label="付款金额"
                size="small"
                :precision="2"
                :min="0"
                :max="editItem.nowPayAmount"
                :step="1"
              ></el-input-number
            ></span>
          </p>
        </el-col>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button @click="editItemCancel">取 消</el-button>
        <el-button type="primary" @click="editItemConfirm"> 选 择 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebSaleReturnOrderSelectDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    from: {
      type: String,
      default: null,
      require: true,
    },
    customerId: {
      type: String,
      default: null,
      require: true,
    },
    selectList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    show: {
      handler(newVal) {
        if (this.from == "FundPayOrder") {
          this.multiSelect = true;
          this.searchParam.fundPayProgressEnumList = ["UnPaid", "PartialPaid"];
          // 为了与查询条件展示一致
          this.searchData.fundPayProgressEnumList = ["UnPaid", "PartialPaid"];
        } else if (this.from == "CommodityInputOrder") {
          this.multiSelect = false;
          this.searchParam.commodityInputProgressEnumList = [
            "NotInput",
            "PartialInput",
          ];
          this.searchData.commodityInputProgressEnumList = [
            "NotInput",
            "PartialInput",
          ];
        }
        this.searchParam.customerId = this.customerId;
        this.search(true);
      },
      immediate: true,
    },
  },
  data() {
    return {
      //   from: "",
      multiSelect: false,

      // 已选列表，多选时需回传
      //   selectList: [],
      showSelectListPopup: false,

      selectFundPayProgressEnumList: [],
      selectCommodityInputProgressEnumList: [],

      // 搜索参数
      searchParam: {
        quickSearchInfoList: [
          {
            columns: [
              "orderNo",
              "customer.customerNo",
              "customerName",
              "customerPhoneNumber",
              "customerAddress",
              "creator.name",
            ],
            quickSearchValue: null,
          },
          {
            columns: ["orderNo"],
            quickSearchValue: null,
          },
          {
            columns: [
              "customer.customerNo",
              "customerName",
              "customerPhoneNumber",
              "customerAddress",
            ],
            quickSearchValue: null,
          },
          {
            columns: ["creator.name"],
            quickSearchValue: null,
          },
        ],
        customerId: null,
        fundPayProgressEnumList: null,
        commodityInputProgressEnumList: null,
        minOrderAmount: null,
        maxOrderAmount: null,
        minCreateDate: null,
        maxCreateDate: null,
        minSubmitDate: null,
        maxSubmitDate: null,
        pageInfo: {
          page: 1,
          pageSize: 10,
        },
        sortInfo: null,
      },

      searchData: {
        searchInputValue: null,
        orderNo: null,
        customerInfo: null,
        creatorName: null,
        minOrderAmount: null,
        maxOrderAmount: null,
        minCreateDate: null,
        maxCreateDate: null,
        minSubmitDate: null,
        maxSubmitDate: null,
      },
      searchLoading: false,
      searchRes: {},

      // 清单
      list: [],
      // 加载更多
      loadMore: {
        status: "loadmore",
        show: false,
      },

      editItemDialogShow: false,
      // 当前选择的item
      editItem: {},
      nowPayAmount: "0.00",
      loading: false,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    // FundPayOrder(multiSelect) | CommodityInputOrder
    select(item) {
      if (this.from == "FundPayOrder") {
        if (!item.collectedMark) {
          this.$message.error(
            "所选销售退货单付款标识为‘未付款’，无法进行付款操作，请选择其他单据"
          );
          return;
        }
      } else if (this.from == "CommodityInputOrder") {
        if (!item.shippedMark) {
          this.$message.error(
            "所选销售退货单发货标识为‘未发货’，无法进行入库操作，请选择其他单据"
          );
          return;
        }
      }
      if (this.multiSelect) {
        let index = this.selectList.findIndex(
          (d) => d.relatedOrderHeadId == item.id
        );
        if (item.fundPayProgressEnum.Name == "NoNeedPaid") {
          this.$message.error("所选销售退货单无需付款，请选择其他单据");
          return;
        }
        if (item.fundPayProgressEnum.Name == "FullPaid") {
          this.$message.error("所选销售退货单已全部付款，请选择其他单据");
          return;
        }
        if (item.toBePayAmount <= 0) {
          this.$message.error("所选销售退货单待付款金额为 0 ，请选择其他单据");
          return;
        }

        if (index > -1) {
          this.editItem = {
            ...item,
          };
          this.nowPayAmount = this.selectList[index].payAmount;
        } else {
          this.editItem = item;
          this.nowPayAmount = item.toBePayAmount;
        }

        this.editItemDialogShow = true;

        // try {
        //   let index = this.selectList.findIndex(
        //     (d) => d.relatedOrderHeadId == item.id
        //   );
        //   if (index > -1) {
        //     this.selectList.splice(index, 1);
        //   } else {
        //     if (item.fundPayProgressEnum.Name == "NoNeedPaid") {
        //       this.$message.error("所选销售退货单无需付款，请选择其他单据");
        //       return;
        //     }
        //     if (item.fundPayProgressEnum.Name == "FullPaid") {
        //       this.$message.error("所选销售退货单已全部付款，请选择其他单据");
        //       return;
        //     }
        //     if (item.toBePayAmount <= 0) {
        //       this.$message.error(
        //         "所选销售退货单待付款金额为 0 ，请选择其他单据"
        //       );
        //       return;
        //     }
        //     let itemNo =
        //       index > -1
        //         ? this.selectList[index].itemNo
        //         : this.selectList && this.selectList.length > 0
        //         ? this.selectList[this.selectList.length - 1].itemNo + 1
        //         : 1;
        //     this.selectList.push({
        //       itemNo: itemNo,
        //       relatedOrderHeadId: item.id,
        //       relatedSaleReturnOrderHead: item,
        //       payAmount: Number(item.toBePayAmount).toFixed(2),
        //       disCountAmount: "0.00",
        //       itemAmount: Number(item.toBePayAmount).toFixed(2),
        //     });
        //   }
        // } finally {
        //   //   setTimeout(() => {
        //   //     uni.hideLoading();
        //   //   }, 200);
        // }
      } else {
        if (item.commodityInputProgressEnum.Name == "NoNeedInput") {
          this.$message.error("所选销售退货单无需入库，请选择其他单据");
          return;
        }
        if (item.commodityInputProgressEnum.Name == "FullInput") {
          this.$message.error("所选销售退货单已全部入库，请选择其他单据");
          return;
        }
        if (item.toBeInputQuantity <= 0) {
          this.$message.error(
            "所选销售退货单待入库商品数量为 0 ，请选择其他单据"
          );
          return;
        }
        this.$confirm("是否选择" + item.orderNo + "？", "操作提醒", {
          confirmButtonText: "选择",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            this.$emit("selectSaleReturnOrder", item);
          })
          .catch(() => {});
      }
    },

    editItemCancel() {
      this.editItemDialogShow = false;
      this.editItem = {};
    },
    editItemConfirm() {
      if (!this.editItem || !this.editItem.orderNo) {
        this.$message({
          message: "请选择销售退货单",
          type: "error",
        });
        return;
      }
      if (Number(this.nowPayAmount) == 0) {
        this.$message({
          message: "请输入付款金额",
          type: "error",
        });
        return;
      }
      try {
        this.loading = true;
        let index = this.selectList.findIndex(
          (d) => d.relatedOrderHeadId == this.editItem.id
        );
        let itemNo =
          index > -1
            ? this.selectList[index].itemNo
            : this.selectList && this.selectList.length > 0
            ? this.selectList[this.selectList.length - 1].itemNo + 1
            : 1;
        let item = {
          itemNo: itemNo,
          relatedOrderHeadId: this.editItem.id,
          relatedSaleReturnOrderHead: this.editItem,
          payAmount: Number(this.nowPayAmount).toFixed(2),
          disCountAmount: "0.00",
          itemAmount: Number(this.nowPayAmount).toFixed(2),
        };
        if (index > -1) {
          this.selectList.splice(index, 1, item);
        } else {
          this.selectList.push(item);
        }
        this.editItemPopupShow = false;
        this.$emit("selectSaleReturnOrder", this.selectList || []);
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (!this.editItemPopupShow) {
          this.$emit("close");
        }
      }
    },

    // 搜索
    handleSizeChange(val) {
      this.searchParam.pageInfo.pageSize = val;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    handleCurrentChange(val) {
      this.searchParam.pageInfo.page = val;
      this.search(false, {
        showSuccessMessage: true,
      });
    },
    changeAndSearch() {
      this.searchParam.quickSearchInfoList[0].quickSearchValue =
        this.searchData.searchInputValue;
      this.searchParam.fundPayProgressEnumList =
        this.searchData.fundPayProgressEnumList;
      this.searchParam.commodityInputProgressEnumList =
        this.searchData.commodityInputProgressEnumList;
      this.searchParam.shippedMark = this.searchData.shippedMark;
      this.searchParam.collectedMark = this.searchData.collectedMark;
      this.searchParam.minOrderAmount = this.searchData.minOrderAmount;
      this.searchParam.maxOrderAmount = this.searchData.maxOrderAmount;
      this.searchParam.minOrderDate = this.searchData.minOrderDate;
      this.searchParam.maxOrderDate = this.searchData.maxOrderDate;
      this.searchParam.minCreateDate = this.searchData.minCreateDate;
      this.searchParam.maxCreateDate = this.searchData.maxCreateDate;
      this.searchParam.minSubmitDate = this.searchData.minSubmitDate;
      this.searchParam.maxSubmitDate = this.searchData.maxSubmitDate;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    resetAndSearch() {
      this.searchData = this.$options.data().searchData;
      this.changeAndSearch();
    },
    sortChange(val) {
      this.searchParam.sortInfo =
        val && val.order
          ? {
              columnName: val.prop,
              order: val.order.replace("ending", "").toUpperCase(),
            }
          : null;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    async search(init, args) {
      this.searchLoading = true;
      if (init) {
        this.searchParam.pageInfo.page = 1;
      }
      let requestRes = await this.$api.saleReturnOrder_findPageForSelect(
        this.searchParam,
        args
      );
      if (requestRes && requestRes.success) {
        this.searchRes = requestRes;
        this.searchRes.pageInfo = requestRes.pageInfo;
        this.$nextTick(() => {
          if (this.$refs.refsTable) {
            this.$refs.refsTable.doLayout();
          }
        });
      }
      if (requestRes.pageCount == 0) {
        this.searchRes = null;
      }
      setTimeout(() => {
        this.searchLoading = false;
      }, 200);
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/SaleReturnOrderSelectDialog.vue